import { Component, inject, Injector, OnInit } from '@angular/core';
import { Database, get, ref, set } from "@angular/fire/database";
import { AuthService } from 'src/app/services/auth.service';
import { BaseComponent } from 'src/app/shared/baseComponent';

@Component({
  selector: 'app-vscenarioedit',
  templateUrl: './vscenarioedit.component.html',
  styleUrls: ['./vscenarioedit.component.css']
})
export class VscenarioeditComponent extends BaseComponent implements OnInit {
  database = inject(Database);
  isAuthenticatedWithFirebase = false
  scenarioid = ""
  scenario: any = {}

  sortArray: any = []
  showinfo = false
  showGroundInfo = false
  showComponentModal = false
  showComponentPropertyModal = false
  component: any = {}
  componentModelTypeId = 0
  ComponentModelTypes = [{ id: 0, name: "ComponentModel" }, { id: 1, name: "CompMultipleModel" }]

  // Camera Config is hardcoded in the game in an enum, so we need to provide the same options here
  cameraConfigs = [{ id: 0, name: "default" }, { id: 1, name: "shoulder_fixed" }, { id: 2, name: "first-person" },]
  cameraConfigId = 0

  // Ground method options
  groundMethods = [
    { id: 0, name: "createStandardGround" },
    { id: 1, name: "createGroundWithRandomTiles" },
    { id: 2, name: "createPBRGround" }
  ]
  groundMethodId = 0

  // Lighting method options
  lightingMethods = [
    { id: 0, name: "createStandardLighting" },
    { id: 1, name: "brightLighting" }
  ]
  lightingMethodId = 0

  // Fog method options
  fogMethods = [
    { id: 0, name: "createStandardFog" },
    { id: 1, name: "noFog" }
  ]
  fogMethodId = 0

  // Fog color options
  fogColors = [
    { id: 0, name: "lightBlue" },
    { id: 1, name: "rainyGray" },
    { id: 2, name: "mistyWhite" },
    { id: 3, name: "overcastGray" },
    { id: 4, name: "duskPurple" },
    { id: 5, name: "forestGreen" }
  ]
  fogColorId = 0

  // sorting state for Components table
  sortComponentsById = false
  sortComponentsByName = false
  sortComponentsByFile = false
  sortComponentsByType = false

  constructor(injector: Injector, private authService: AuthService) {
    super(injector)
  }
  async ngOnInit(): Promise<void> {
    this.scenarioid = this.getQueryParameter('id')

    this.isAuthenticatedWithFirebase = await this.authService.initializeAuth(() => this.onSuccessfullLogin())
    if (this.scenarioid == "-1") {
      this.showComponentPropertyModal = true
    } else {
      await this.getData()
    }
  }

  async signInWithGoogle() {
    this.isAuthenticatedWithFirebase = await this.authService.signInWithGoogle()
    if (this.isAuthenticatedWithFirebase) { await this.onSuccessfullLogin() }
  }

  private async onSuccessfullLogin() {
    await this.getData()
  }

  getData = async () => {
    this.loader.show()

    const scenarioRef = ref(this.database, 'scenarios/' + this.scenarioid);
    const snapshot = await get(scenarioRef);

    if (snapshot.exists()) {
      this.scenario = snapshot.val()
      this.cameraConfigs.forEach((config: any, index: number) => {
        if (config.name == this.scenario.cameraConfig) {
          this.cameraConfigId = index
        }
      })
      // Sync ground method
      if (this.scenario.ground?.methodName) {
        this.groundMethods.forEach((method: any, index: number) => {
          if (method.name == this.scenario.ground.methodName) {
            this.groundMethodId = index
          }
        })
      }
      if (this.scenario.ground && this.scenario.ground.extensionYOffset == null) {
        this.scenario.ground.extensionYOffset = -0.05
      }
      // Sync lighting method
      if (this.scenario.lighting?.methodName) {
        this.lightingMethods.forEach((method: any, index: number) => {
          if (method.name == this.scenario.lighting.methodName) {
            this.lightingMethodId = index
          }
        })
      }
      // Sync fog method
      if (this.scenario.fog?.methodName) {
        this.fogMethods.forEach((method: any, index: number) => {
          if (method.name == this.scenario.fog.methodName) {
            this.fogMethodId = index
          }
        })
      }
      // Sync fog color
      if (this.scenario.fog?.fogColor) {
        this.fogColors.forEach((color: any, index: number) => {
          if (color.name == this.scenario.fog.fogColor) {
            this.fogColorId = index
          }
        })
      }
      if (this.scenario.components == null) {
        this.scenario.components = []
      }

      if (this.scenario.lessonplan != null) {
        let steps = BaseComponent.toArray(this.scenario.lessonplan)
        steps = this.sort(steps, "seqNo")
        this.scenario.lessonplan = steps
      } else {
        this.scenario.lessonplan = []
      }

      if (this.scenario.interactivities == null) {
        this.scenario.interactivities = []
      }
      this.scenario.interactivities = this.sort(this.scenario.interactivities, "seqNo")
      if (this.scenario.modifiers == null) {
        this.scenario.modifiers = []
      }
    }
    this.loader.hide()
  }

  save = async () => {


    // Sync ground method selection back to scenario object
    if (this.scenario.ground && this.groundMethods[this.groundMethodId]) {
      this.scenario.ground.methodName = this.groundMethods[this.groundMethodId].name
    }

    // Sync lighting method selection back to scenario object
    if (this.scenario.lighting) {
      this.scenario.lighting.methodName = this.lightingMethods[this.lightingMethodId].name
    } else {
      this.scenario.lighting = { methodName: this.lightingMethods[this.lightingMethodId].name }
    }

    // Sync fog method selection back to scenario object
    if (this.scenario.fog) {
      this.scenario.fog.methodName = this.fogMethods[this.fogMethodId].name
      this.scenario.fog.fogColor = this.fogColors[this.fogColorId].name
    } else {
      this.scenario.fog = { 
        methodName: this.fogMethods[this.fogMethodId].name,
        fogColor: this.fogColors[this.fogColorId].name
      }
    }

    this.loader.show()
    await set(ref(this.database, 'scenarios/' + this.scenarioid), this.scenario)
    this.loader.hide()
  }

  addComponent(component: any) {
    this.component = component
    if (this.component == null) {
      this.component = {
        id: Array.from({ length: 6 }, () => String.fromCharCode(97 + Math.floor(Math.random() * 26))).join(''),
        file: "*.glb",
        name: "Name",
        posX: 0,
        posY: 0,
        posZ: 0,
        rotX: 0,
        rotY: 0,
        rotZ: 0,
        scale: 1,
        type: "ComponentModel",
        enabled: true,
        isPickable: false,
        checkCollisions: false,
        isVisible: true
      }
      this.scenario.components.push(this.component)
    }
    this.showComponentModal = true
  }

  async updateComponentProperty() {
    this.showComponentPropertyModal = false
    this.scenarioid = this.component.id
    this.scenario = {
      name: this.component.id,
      isVersion2: true,
      description: "Describe your scenario here",
      cameraConfig: ""
    }
    await this.save()
    this.router.navigate(['vscenarios'], {})
  }

  async updateComponent() {
    this.loader.show()
    this.component.type = this.ComponentModelTypes[this.componentModelTypeId].name
    await this.save()
    await this.getData()
    this.showComponentModal = false
    this.loader.hide()
  }

  async deleteComponent(component: any) {
    this.loader.show()
    this.scenario.components = this.scenario.components.filter((comp: any) => comp.id != component.id)
    await this.save()
    await this.getData()
    this.loader.hide()
  }

  sortComponentBy(what: any) {
    if (what == "name") {
      this.sortComponentsByName = this.sortUpDown(this.scenario.components, "name", this.sortComponentsByName)
    }
    if (what == "file") {
      this.sortComponentsByFile = this.sortUpDown(this.scenario.components, "file", this.sortComponentsByFile)
    }
    if (what == "type") {
      this.sortComponentsByType = this.sortUpDown(this.scenario.components, "type", this.sortComponentsByType)
    }
    if (what == "id") {
      this.sortComponentsById = this.sortUpDown(this.scenario.components, "id", this.sortComponentsById)
    }
  }
}
